export default {
    apiUrl: "https://unihub.uniqa.cz/hyperionapi/api",
    authUrl: "https://login.uniqa.cz/auth/realms/people/protocol/openid-connect",
    authRedirectUri: "https://unihub.uniqa.cz",
    damageReportUrl: "https://skody.uniqa.cz/form/redirect/",
    damageReportUrlBaseSK: "https://skody.uniqa.sk/",
    wsUrl: "",
    envName: "" 
}